import React, { useEffect, useState } from "react";
import { MenuKey, ViewMode } from "../data/navigation";
import { SiteHeader } from "../components/SiteHeader";
import { SiteHero } from "../components/SiteHero";
import { MobileNav } from "../components/MobileNav";
import { IAComparison } from "../components/IAComparison";
const viewOptions: {
  value: ViewMode;
  label: string;
  hint: string;
}[] = [{
  value: "current",
  label: "Current",
  hint: "About Us"
}, {
  value: "proposed",
  label: "Proposed",
  hint: "Why i9 Sports"
}];
export function NavigationConcept() {
  const [view, setView] = useState<ViewMode>("proposed");
  const [showNotes, setShowNotes] = useState(true);
  const [openMenu, setOpenMenu] = useState<MenuKey | null>("brand");
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpenMenu(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  const changeView = (v: ViewMode) => {
    setView(v);
    setOpenMenu(m => m ?? "brand");
  };
  return <main className="min-h-screen w-full bg-i9-mist text-i9-ink" data-id="element-259" data-mp="3tegb20k42bs3">
      {/* Presenter bar */}
      <div className="sticky top-0 z-40 border-b border-i9-line bg-white/95 backdrop-blur" data-id="element-260" data-mp="285hephfkdas">
        <div className="mx-auto flex max-w-[1320px] flex-wrap items-center justify-between gap-4 px-6 py-4" data-id="element-261" data-mp="3kfl8qzk6tlu2">
          <div data-id="element-262" data-mp="3ph23edc2wc27">
            <p className="text-xs font-semibold uppercase tracking-wide text-i9-red" data-id="element-263" data-mp="3aq1nxocwzhwk">Navigation concept</p>
            <h1 className="font-display text-2xl font-extrabold uppercase leading-tight text-i9-navy" data-id="element-264" data-mp="3fgi1r9knd5jg">
              About Us → Why <span className="normal-case" data-id="element-265" data-mp="31q68368eyyq7">i9</span> Sports
            </h1>
          </div>
          <div className="flex items-center gap-6" data-id="element-266" data-mp="35qgolctu17jb">
            <div role="radiogroup" aria-label="Menu version" className="flex bg-i9-mist p-1" data-id="element-267" data-mp="35ovsvjvs7ijv">
              {viewOptions.map(o => {
              const selected = view === o.value;
              return <button key={o.value} role="radio" aria-checked={selected} onClick={() => changeView(o.value)} className={`px-4 py-2 text-left transition-colors duration-150 ease-out ${selected ? "bg-i9-navy text-white" : "text-i9-navy hover:bg-white"}`} data-id="element-268" data-mp="2ws4nggvcarcm">
                    <span className="block text-sm font-bold uppercase" data-id="element-269" data-mp="1l8o1ogv01vpj">{o.label}</span>
                    <span className={`block whitespace-nowrap text-xs ${selected ? "text-white/70" : "text-i9-ink/60"}`} data-id="element-270" data-mp="1h7ceehzllmki">{o.hint}</span>
                  </button>;
            })}
            </div>
            <label className="flex cursor-pointer items-center gap-3 text-sm font-semibold text-i9-navy" data-id="element-271" data-mp="179o9x0c6x0p5">
              <button type="button" role="switch" aria-checked={showNotes} onClick={() => setShowNotes(s => !s)} className={`relative h-6 w-11 rounded-full transition-colors duration-150 ease-out ${showNotes ? "bg-i9-blue" : "bg-i9-line"}`} data-id="element-272" data-mp="tm24nybrrzs">
                <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ease-out ${showNotes ? "translate-x-[22px]" : "translate-x-0.5"}`} data-id="element-273" data-mp="3mutdakc0wyu4" />
              </button>
              <span className="whitespace-nowrap" data-id="element-274" data-mp="4fr91udf74z5">Show change notes</span>
            </label>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1320px] px-6 py-10" data-id="element-275" data-mp="9hgij5kzval4">
        {/* Desktop */}
        <section aria-labelledby="desktop-heading" data-id="element-276" data-mp="efhz9juy6xtf">
          <div className="mb-4 flex flex-wrap items-end justify-between gap-2" data-id="element-277" data-mp="je32zt9erzmm">
            <h2 id="desktop-heading" className="font-display text-xl font-extrabold uppercase text-i9-navy" data-id="element-278" data-mp="2g6cyyms9zh5f">
              Desktop mega menu
            </h2>
            <div className="flex items-center gap-1 text-sm" role="group" aria-label="Open a menu" data-id="element-279" data-mp="2l5g6qezn41h3">
              <span className="mr-1 text-i9-ink/60" data-id="element-280" data-mp="ff2r9z6vhvnd">Open menu:</span>
              {(["programs", "brand", "contact"] as MenuKey[]).map(k => <button key={k} onClick={() => setOpenMenu(m => m === k ? null : k)} aria-pressed={openMenu === k} className={`px-3 py-1.5 font-semibold transition-colors duration-150 ease-out ${openMenu === k ? "bg-i9-blue text-white" : "bg-white text-i9-navy hover:bg-i9-line"}`} data-id="element-281" data-mp="oi3w7wk05gpg">
                  {k === "programs" ? "Programs" : k === "contact" ? "Contact" : view === "proposed" ? "Why i9 Sports" : "About Us"}
                </button>)}
            </div>
          </div>
          <div className="overflow-x-auto shadow-[0_20px_50px_-24px_rgba(22,21,74,0.45)]" data-id="element-282" data-mp="396rnj5mi6njj">
            <div className="min-w-[1180px] overflow-hidden border border-i9-line bg-white" data-id="element-283" data-mp="349hz9tauohxa">
              <div className="flex h-9 items-center gap-2 border-b border-i9-line bg-[#f3f4f7] px-4" aria-hidden="true" data-id="element-284" data-mp="1jqfkwqzo6w5u">
                <span className="h-3 w-3 rounded-full bg-i9-line" data-id="element-285" data-mp="1oi7cn4ukb7xk" />
                <span className="h-3 w-3 rounded-full bg-i9-line" data-id="element-286" data-mp="1aqj2v87scvjr" />
                <span className="h-3 w-3 rounded-full bg-i9-line" data-id="element-287" data-mp="1ao6as28bd4sz" />
                <span className="ml-4 flex h-6 flex-1 max-w-md items-center rounded bg-white px-3 text-xs text-i9-ink/50" data-id="element-288" data-mp="1fplwzxm89hcy">
                  i9sports.com/{view === "proposed" ? "why-i9-sports" : "about-us"}
                </span>
              </div>
              <SiteHeader view={view} showNotes={showNotes} openMenu={openMenu} onToggleMenu={k => setOpenMenu(m => m === k ? null : k)} data-id="element-289" data-mp="1tgr1bd0jixtm" />
              <SiteHero view={view} data-id="element-290" data-mp="i12ceg3q7oq6" />
            </div>
          </div>
        </section>

        {/* Mobile + IA */}
        <section aria-labelledby="mobile-heading" className="mt-16" data-id="element-291" data-mp="n17yzhv52l1e">
          <h2 id="mobile-heading" className="mb-6 font-display text-xl font-extrabold uppercase text-i9-navy" data-id="element-292" data-mp="2ytwu6jd1h7m">
            Mobile navigation & information architecture
          </h2>
          <div className="grid items-start gap-12 lg:grid-cols-[360px_1fr]" data-id="element-293" data-mp="3qbeeaz30kcge">
            <div className="flex justify-center" data-id="element-294" data-mp="3q9a0npfbbz2x">
              <MobileNav key={view} view={view} showNotes={showNotes} data-id="element-295" data-mp="3ld32iit5rrvj" />
            </div>
            <div className="bg-white p-8 lg:p-10" data-id="element-296" data-mp="3gdqaljnfjum3">
              <IAComparison data-id="element-297" data-mp="3gb40bc95n106" />
            </div>
          </div>
        </section>
      </div>
    </main>;
}